import { atom, useAtom, useSetAtom } from 'jotai';

import { BudgetRows } from '../types/predictivePlanning.js';

const budgetAtom = atom<number | null>(null);
const budgetRowsAtom = atom<BudgetRows | null>(null);

export const usePredictiveBudget = () => {
  return useAtom(budgetAtom);
};

export const useSetPredictiveBudget = () => {
  return useSetAtom(budgetAtom);
};

export const useGetBudgetRows = () => {
  return useAtom(budgetRowsAtom);
};

export const useSetBudgetRows = () => {
  return useSetAtom(budgetRowsAtom);
};
